import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const UrgentAlarmGlyph = /*#__PURE__*/createElement("g", {
  id: "urgent_alarm"
}, /*#__PURE__*/createElement("path", {
  d: "M67.8,57.7c0-0.1,0-0.1-0.1-0.1C61.3,55,57,49,56.6,42.2c-0.3-4.7-0.5-9.5-0.8-14.2c-0.1-2.6-2.3-4.7-5-4.7h-5.4h-7h-5.4 c-2.6,0-4.8,2.1-5,4.7c-0.3,4.7-0.5,9.5-0.8,14.2C27,49,22.7,55,16.3,57.6c-0.1,0-0.1,0.1-0.1,0.1v2.9c0,0.1,0,0.1,0.1,0.1h51.3 c0.1,0,0.2,0,0.2-0.1V57.7z M38.5,20.3h7v-3.5c0-1.9-1.6-3.5-3.5-3.5c-1.9,0-3.5,1.6-3.5,3.5V20.3z M40.4,69.5 c-2.6-0.7-4.4-3.1-4.4-5.8H15.7c-1.3,0-2.4-1.1-2.4-2.4v-4c0-1,0.6-1.9,1.6-2.3c5.5-2,9.3-7.1,9.6-13c0.3-4.7,0.5-9.5,0.8-14.2 c0.2-4.2,3.7-7.5,7.9-7.5h2.4v-3.5c0-3.6,2.9-6.5,6.5-6.5c3.6,0,6.5,2.9,6.5,6.5v3.5h2.4c4.2,0,7.7,3.3,7.9,7.5 c0.3,4.7,0.5,9.5,0.8,14.2c0.3,5.8,4.1,10.9,9.6,13c1,0.4,1.6,1.3,1.6,2.3v4c0,1.3-1.1,2.4-2.4,2.4H48c0,2.7-1.8,5-4.4,5.8v2.6 c0,0.9-0.7,1.6-1.6,1.6c-0.9,0-1.6-0.7-1.6-1.6V69.5"
}));
const UrgentAlarm = createSvg({
  name: 'urgent_alarm',
  path: UrgentAlarmGlyph
});

export default UrgentAlarm;
export { UrgentAlarmGlyph };
